export default "__VITE_ASSET__BKOpUHey__"